/**
 * Utilitaires pour les modals
 */

/**
 * Scroll vers le modal pour s'assurer qu'il est visible
 * @param {HTMLElement} modalElement - Élément du modal
 * @param {object} options - Options de scroll
 */
export const scrollToModal = (modalElement, options = {}) => {
  if (!modalElement) return

  const defaultOptions = {
    behavior: 'smooth',
    block: 'center',
    inline: 'nearest'
  }

  const scrollOptions = { ...defaultOptions, ...options }

  // Délai pour laisser l'animation se terminer
  setTimeout(() => {
    modalElement.scrollIntoView(scrollOptions)
  }, 100)
}

/**
 * Sauvegarde la position de scroll actuelle
 * @returns {number} Position de scroll
 */
export const saveScrollPosition = () => {
  return window.pageYOffset || document.documentElement.scrollTop
}

/**
 * Restaure la position de scroll
 * @param {number} position - Position de scroll à restaurer
 */
export const restoreScrollPosition = (position) => {
  if (position !== undefined) {
    window.scrollTo(0, position)
  }
}

/**
 * Scroll vers le haut de la page
 * @param {object} options - Options de scroll
 */
export const scrollToTop = (options = {}) => {
  const defaultOptions = {
    behavior: 'smooth',
    top: 0
  }

  const scrollOptions = { ...defaultOptions, ...options }
  window.scrollTo(scrollOptions)
}

/**
 * Vérifie si un élément est visible dans le viewport
 * @param {HTMLElement} element - Élément à vérifier
 * @returns {boolean} True si l'élément est visible
 */
export const isElementVisible = (element) => {
  if (!element) return false

  const rect = element.getBoundingClientRect()
  const windowHeight = window.innerHeight || document.documentElement.clientHeight
  const windowWidth = window.innerWidth || document.documentElement.clientWidth

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= windowHeight &&
    rect.right <= windowWidth
  )
}

export default {
  scrollToModal,
  saveScrollPosition,
  restoreScrollPosition,
  scrollToTop,
  isElementVisible
}
